import React, { useState } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { labDetail } from "../store/Slice/labSlice";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import moment from "moment";
import PictureAsPdfTwoToneIcon from "@mui/icons-material/PictureAsPdfTwoTone";
import InsertDriveFileTwoToneIcon from "@mui/icons-material/InsertDriveFileTwoTone";
import { REPORT_FORM } from "../Config";
import ReactApexChart from "react-apexcharts";
import AddchartTwoToneIcon from "@mui/icons-material/AddchartTwoTone";
import urlParams from "../Services/urlParams";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function LabDetail() {
  const lab = useSelector(({ lab }) => lab);
  const dispatch = useDispatch();
  const location = useLocation();
  let { id } = useParams();

  const [checkbox, setCheckbox] = useState([]);

  const urlWithParams = urlParams.urlWithParams(location);

  useEffect(() => {
    dispatch(labDetail(id));
  }, []);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (chart) => {
    setDataChart({
      name: chart.name,
      data: chart.data,
      categories_type: "datetime",
      categories: chart.categories,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [dataChart, setDataChart] = useState({
    name: "",
    data: [],
    categories_type: "datetime",
    categories: [],
  });

  const config = {
    series: [
      {
        name: dataChart.name,
        data: dataChart.data,
      },
    ],

    options: {
      chart: {
        height: 100,
        type: "area",
        // toolbar: {
        //   show: false, // แสดง toolbar
        // },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: dataChart.categories_type,
        categories: dataChart.categories,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    },
  };
  return (
    <ContentPage
      image_icon={process.env.PUBLIC_URL + "/icons/test.png"}
      title="Lab Result"
      TitlePageMenulist={[
        {
          label: "หน้าแรก",
          href: `/lab${urlWithParams}`,
          icon: <HomeIcon fontSize="small" />,
        },
        {
          label: "Lab Result",
          href: `/lab/detail/${id}${urlWithParams}`,
          icon: <DescriptionTwoToneIcon fontSize="small" />,
        },
      ]}
    >
      <Paper sx={{ p: 2 }} elevation={1}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              ชื่อ - นามสกุล :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.patient_name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              เพศ :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.sex_name}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              วันเดือนปีเกิด :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {moment(lab.detailResult?.birthday).format("L")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              อายุ :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.patient_age_full}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              LN :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.lab_order_id}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              Ward :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.ward_name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              HN :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {lab.detailResult?.hn}
            </Typography>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ mr: 1, fontWeight: "bold", fontSize: "16px" }}
            >
              วันที่สั่ง :
            </Typography>
            <Typography
              variant="body2"
              component={"span"}
              sx={{ fontSize: "16px" }}
            >
              {moment(lab.detailResult?.lab_order_date).format("D/M/YYYY")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex" }}>
              <Tooltip title="พิมพ์ PDF" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์"
                  sx={{ width: 27, height: 27, cursor: "pointer", mr: 1 }}
                  src={process.env.PUBLIC_URL + "/pdf.png"}
                  onClick={() => {
                    const queryString = checkbox.join(",");
                    window.open(
                      `${REPORT_FORM}pdf/${id}?items=${queryString}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
              <Tooltip title="พิมพ์สติ๊กเกอร์" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์สติ๊กเกอร์"
                  sx={{ width: 27, height: 27, cursor: "pointer", mr: 1 }}
                  src={process.env.PUBLIC_URL + "/stickerReport.png"}
                  onClick={() => {
                    const queryString = checkbox.join(",");
                    window.open(
                      `${REPORT_FORM}sticker/${id}?items=${queryString}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
              <Tooltip title="พิมพ์รูป PDF" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์รูป PDF"
                  sx={{ width: 27, height: 27, cursor: "pointer" }}
                  src={process.env.PUBLIC_URL + "/icons/google-docs.png"}
                  onClick={() => {
                    window.open(`${REPORT_FORM}pdf_image/${id}`, "_blank");
                  }}
                />
              </Tooltip>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 1, mt: 2 }}>
        <TableContainer sx={{ mt: 1 }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead sx={{ bgcolor: "#fcce95" }}>
              <TableRow>
                <TableCell
                  colSpan={2}
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  รายการ
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  ค่าที่รายงาน
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  ผิดปกติ
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  หน่วย
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  ค่าปกติ
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  Method
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lab.detailItem.map((opt, i) => (
                <React.Fragment key={i}>
                  {opt.profile_name ? (
                    <React.Fragment>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          colSpan={8}
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          {opt.profile_name}
                        </TableCell>
                      </TableRow>
                      {opt.items_list.map((row, key) => (
                        <TableRow
                          key={`${i}-${key}`}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ whiteSpace: "nowrap", padding: 0 }}
                          >
                            <Checkbox
                              {...label}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  // ถ้าเลือกให้เพิ่ม index ใน array
                                  setCheckbox((prev) => [
                                    ...prev,
                                    row.lab_items_id,
                                  ]);
                                } else {
                                  // ถ้าไม่เลือกให้ลบ index ออกจาก array
                                  setCheckbox((prev) =>
                                    prev.filter((i) => i !== row.lab_items_id)
                                  );
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.lab_items_name}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.show_text ? row.show_text : row.lab_result}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.abnormal_status}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.lab_items_unit_name}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.lab_items_normal_value_2
                              ? row.lab_items_normal_value_2
                              : row.lab_items_normal_value}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row.method_name}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {!isNaN(row.lab_result) && (
                              <Button
                                startIcon={<AddchartTwoToneIcon />}
                                onClick={() => {
                                  handleClickOpen(row.chart);
                                }}
                              >
                                กราฟ
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  ) : (
                    opt.items_list.map((row, key) => (
                      <TableRow
                        key={`${i}-${key}`}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ whiteSpace: "nowrap", padding: 0 }}
                        >
                          <Checkbox
                            {...label}
                            onChange={(e) => {
                              if (e.target.checked) {
                                // ถ้าเลือกให้เพิ่ม index ใน array
                                setCheckbox((prev) => [
                                  ...prev,
                                  row.lab_items_id,
                                ]);
                              } else {
                                // ถ้าไม่เลือกให้ลบ index ออกจาก array
                                setCheckbox((prev) =>
                                  prev.filter((i) => i !== row.lab_items_id)
                                );
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          {row.lab_items_name}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          {row.lab_result}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          {row.abnormal_status}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          {row.lab_items_unit_name}
                        </TableCell>
                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                          {row.lab_items_normal_value_2
                            ? row.lab_items_normal_value_2
                            : row.lab_items_normal_value}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          {row.method_name}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                          {!isNaN(row.lab_result) && (
                            <Button
                              startIcon={<AddchartTwoToneIcon />}
                              onClick={() => {
                                handleClickOpen(row.chart);
                              }}
                            >
                              กราฟ
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Chart"}</DialogTitle>
        <DialogContent>
          <ReactApexChart
            options={config.options}
            series={config.series}
            type="area"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            ปิด
          </Button>
        </DialogActions>
      </Dialog>
    </ContentPage>
  );
}
